<template>
  <div :class="classes" :style="{ gap: computedGap }">
    <slot />
  </div>
</template>

<script>
export default {
  /**
   * レスポンシブ対応とGapプロパティをベースにした、Flexコンポーネントを作成中です
   * 主な相違点: スペースがgapベース、spaceは0がdefault
   */
  name: 'Flex',
  props: {
    gap: {
      type: [Number, String],
      default: undefined,
    },
    space: {
      type: [Number, String],
      default: 0,
    },
    column: {
      type: Boolean,
      default: false,
    },
    justify: {
      type: String,
      default: 'start',
    },
    align: {
      type: String,
      default: 'stretch',
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'd-flex': true,
        [`space-${this.space}`]: true,
        [`align-${this.align}`]: true,
        [`justify-${this.justify}`]: true,
        'flex-row': !this.column,
        'flex-column': this.column,
        'flex-wrap': this.wrap,
        'full-width': this.fullWidth,
      }
    },
    
    computedGap() {
      return this.space ? `${Number(this.space) * 4}px` : this.gap
    },
  },
}
</script>

<style scoped>
.flex-row > * {
  min-width: 0;
}
</style>
